import { login, logout, getInfo } from '@/api2/user'
import { getToken, setToken, removeToken } from '@/utils/auth'

const user = {
  state: {
    token: getToken(),
    name: '',
    avatar: '',
    roles: [],
    userId: '',
    routerApply:0,
    userInfo:{}
  },

  mutations: {
    SET_USERINFO:(state, userInfo) =>{
      state.userInfo = userInfo
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_USERID: (state, roles) => {
      state.userId = roles
    },
    ROUTE_APPLY:(state, routerApply) =>{
      state.routerApply = routerApply
    }
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      const username = userInfo.username.trim()
      return new Promise((resolve, reject) => {
        login(userInfo).then(response => {
          const data = response.data
          const tokenStr = data.token
          setToken(tokenStr)
          commit('SET_TOKEN', tokenStr)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetInfo({ commit, state }) {
      document.cookie = getToken()
      return new Promise((resolve, reject) => {
        getInfo({methodCode:'v1.account.info'}).then(response => {
          const data = response.data
          commit('ROUTE_APPLY', 1)
          if (data.userMenu && data.userMenu.length >= 0) { // 验证返回的roles是否是一个非空数组
            commit('SET_ROLES', data.userMenu)
          }
          // else if (data.userMenu.length == 0) {
          //   router.push({ path: '/home'});
          // }
          else {
            reject('您已被登出 !')
          }
          commit('SET_USERINFO', data.adminUser)
          commit('SET_NAME', data.adminUser.nickname)
          commit('SET_USERID', data.adminUser.id)

          commit('SET_AVATAR', '/static/image/index/avatar.png')
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout({methodCode:'v1.account.logout'}).then(() => {
          // this.$router.push({path: '/login'})
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          removeToken()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js